<template>
  <div class="user-import">
    <div class="user-import__header">
      <h3>{{ title }}</h3>
      <div v-loading="loading">
        <el-upload
          ref="upload"
          class="user-import__upload"
          :multiple="false"
          action="/api/import/upload"
          accept=".csv, .xls, .xlsx"
          :limit="1"
          :headers="headers"
          :on-success="showResult"
          :before-upload="beforeUpload"
          :on-exceed="onExceed"
          :with-credentials="true"
          :on-error="onError"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">
            Seleccionar archivo
          </el-button>
          <el-button
            style="margin-left: 10px;"
            size="small"
            type="success"
            @click="submit">
            Procesar importación
          </el-button>
          <div slot="tip" class="el-upload__tip">
            Se acepta unicamente archivo en formato CSV
          </div>
        </el-upload>
        <span class="user-import__upload-error">
          {{ errorMessage }}
        </span>
      </div>
    </div>
    <div v-if="loading || processed" class="user-import__body">
      <div>Total registros: <strong>{{ totalRecords }}</strong> </div>
      <template v-if="result">
        <div>
          <div>Registros insertados: <strong>{{ result.totalSuccess }}</strong> </div>
          <div>Registros con errores: <strong>{{ result.totalErrors }}</strong> </div>
          <div>
            <el-table
              :data="result.errorDetails"
              :row-class-name="errorType"
              class="user-import__error-table"
              style="width: 100%">
              <el-table-column
                prop="index"
                label="#"
                width="20" />
              <el-table-column
                prop="rut"
                label="RUT"
                width="180" />
              <el-table-column
                prop="type"
                label="tipo"
                width="100" />
              <el-table-column
                prop="value"
                label="Mensaje" />
            </el-table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const LOCAL_STORE_PREFIX = process.env.VUE_APP_LOCAL_STORE_PREFIX;
export default {
  name: 'UserImport',
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      maxFileSize: 10240, // kilobytes
      loading: false,
      processed: false,
      totalRecords: 0,
      result: null,
      errorMessage: '',
      FileTypeAllowed: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
        'application/vnd.ms-excel'
      ]
    };
  },

  computed: {
    headers() {
      const token = localStorage.getItem(`${LOCAL_STORE_PREFIX}-user-token`);
      return {
        'authorization': `Bearer ${token}`
      };
    }
  },

  methods: {
    submit() {
      this.$refs.upload.submit();
    },
    beforeUpload(file) {
      console.log(`TIPO DE ARCHIVO: ${file.type}`);
      const isFileTypeAllowed = this.FileTypeAllowed.includes(file.type);
      const isTooLarge = file.size / 1024 > this.maxFileSize;

      if (!isFileTypeAllowed) {
        this.$message.error('El archivo no es el formato correcto');
      }
      if (isTooLarge) {
        this.$message.error('El archivo es muy grande');
      }
      return isFileTypeAllowed && !isTooLarge;
    },
    showResult(response, file, fileList) {
      if (!Array.isArray(response)) {
        this.showError('Ocurrió un error al procesar el archivo, por favor verifique');
        return;
      }
      this.loading = true;
      this.totalRecords = response.length;
      this.$store.dispatch('processImport', response)
        .then(data => { this.result = data; this.processed = true; })
        .catch(err => { this.showError(err.message); })
        .finally(() => { this.loading = false; });
    },
    onExceed({ files, fileList }) {
      this.showError('Solo se permite 1 archivo.');
    },
    onError(err, file, filelist) {
      this.showError(err);
    },
    showError(message) {
      this.errorMessage = message;
      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    },
    errorType({ row, index }) {
      return row.type;
    }
  }
};
</script>

<style lang="scss">
  .user-import{
    padding: $--spacing-6;

    &__header{
      display: flex;
      justify-content: space-between;
      padding-bottom: $--spacing-6;
      margin-bottom: $--spacing-6;
      border-bottom: 1px solid $--color-light-gray;
    }

    &__error-table{
      .warning{
        background-color: rgb(248, 255, 185);
      }
      .error{
        background-color: rgb(255, 214, 214);
      }
    }

    &__upload-error{
      font-size: 12px;
      color: red;
      font-weight: bold;
    }
  }
</style>
